import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GeofenceDTO } from "../Geofence";
import { TitleService } from "src/app/title.service";
import { MatDialog } from "@angular/material/dialog";
import { GeofenceService } from "../geofence.service";
import { SessionService } from "src/app/session.service";
import { NotificationService } from "src/app/notifications/notification.service";
import { Address } from "ngx-google-places-autocomplete/objects/address";
import { GoogleMap } from "@angular/google-maps";
import { LatLng } from "ngx-google-places-autocomplete/objects/latLng";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { MatSort } from "@angular/material/sort";
import { FacilityDTO } from "src/app/facilities/Facility";
import { UiService } from "src/app/ui/ui.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-geofence",
  templateUrl: "./geofence.component.html",
  styleUrls: ["./geofence.component.scss"],
})
export class GeofenceComponent implements OnInit, AfterViewInit {
  newGeofence!: boolean;
  geofence?: GeofenceDTO;

  geofenceForm!: FormGroup;
  facilityControl!: FormControl;

  locationName: any;
  placeName: string = "";

  @ViewChild(GoogleMap, { static: true }) map?: GoogleMap;
  mapOptions: google.maps.MapOptions = {
    streetViewControl: false,
    center: this.newGeofence ? { lat: 0, lng: 0 } : { lat: 38, lng: -100 },
    zoom: 3,
  };
  allShapes: any[] = [];
  currentCircle?: google.maps.Circle;
  circleCenter?: LatLng;
  circleRadius?: number;

  currentPolygon?: google.maps.Polygon;
  area?: any;

  drawingManager?: google.maps.drawing.DrawingManager;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  facilities?: FacilityDTO[];

  firstView: boolean = true;

  @ViewChild("geofencesTable") geofencesTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  intersectingGeofences?: GeofenceDTO[];
  intersectionsDataSource!: MatTableDataSource<any>;
  intersectionsColumns = ["id", "name", "options"];
  hasFacilitiesList: boolean = false;
  private onComponentDestroy = new Subject();

  constructor(
    private activatedRoute: ActivatedRoute,
    private TitleService: TitleService,
    private dialog: MatDialog,
    private router: Router,
    private GeofenceService: GeofenceService,
    private SessionService: SessionService,
    private NotificationService: NotificationService,
    private uiService: UiService,
  ) {}

  _updateData() {
    this.geofence = this.activatedRoute.snapshot.data.geofence;
    this.intersectingGeofences =
      this.activatedRoute.snapshot.data.intersectingGeofences;
    this.intersectionsDataSource = new MatTableDataSource(
      this.intersectingGeofences,
    );
    this.facilities = this.activatedRoute.snapshot.data.facilities.records;
    this.newGeofence = !this.geofence;

    if (!this.newGeofence) {
      this.TitleService.setTitle(
        this.TitleService.getTitle() + ` | ${this.geofence?.name}`,
      );
    }
  }

  ngOnInit(): void {
    this.hasFacilitiesList =
      this.activatedRoute.snapshot.data.permissions.hasFacilitiesList;

    this.activatedRoute.params
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        this._updateData();
        this.initForms();
        if (!this.firstView) {
          this.initMap();
        }
      });

    this.firstView = false;
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  initForms() {
    this.facilityControl = new FormControl(this.geofence?.facility_floor_id);

    this.geofenceForm = new FormGroup({
      placeName: new FormControl(this.placeName),
      geofenceName: new FormControl(this.geofence?.name, [Validators.required]),
      geofenceTimeout: new FormControl(this.geofence?.timeout, [
        Validators.required,
      ]),
      minAccuracy: new FormControl(this.geofence?.min_accuracy),
      onProperty: new FormControl(this.geofence?.on_property || false),
      facilityFloorId: this.facilityControl,
      foreignId: new FormControl(this.geofence?.foreign_key),
      uid: new FormControl(this.geofence?.uid),
      tags: new FormControl(this.geofence?.tags),
      competitor: new FormControl(this.geofence?.competitor || false),
    });

    if (this.newGeofence) {
      this.geofenceForm.controls.tags.setValue([]);
    }

    //Disable as user wont be able to select facility floor
    if (!this.hasFacilitiesList) {
      this.geofenceForm.controls.onProperty.disable();
      this.geofenceForm.controls.facilityFloorId.disable();
    }
  }

  initMap() {
    if (this.map) {
      this.clearShapes();

      // render intersecting
      this._renderIntersecting();

      // render geofence
      if (
        this.geofence?.roundAsGeoJson !== undefined &&
        this.geofence.roundAsGeoJson !== null
      ) {
        this.currentCircle = this.addCircle(
          this.geofence.roundAsGeoJson,
          this.geofence?.round_radius!,
          true,
        );
        this.allShapes.push(this.currentCircle);
      } else if (
        this.geofence?.areaAsGeoJson !== undefined &&
        this.geofence?.areaAsGeoJson !== null
      ) {
        this.currentPolygon = this.addPolygon(
          this.geofence.areaAsGeoJson,
          true,
        );
        this.allShapes.push(this.currentPolygon);
      }

      // init drawing
      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: false,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            google.maps.drawing.OverlayType.CIRCLE,
            google.maps.drawing.OverlayType.POLYGON,
          ],
        },
        polygonOptions: {
          fillColor: "#333333",
          fillOpacity: 0.1,
          strokeWeight: 3,
          strokeColor: "#000000",
          strokeOpacity: 0.8,
          clickable: false,
          editable: true,
          zIndex: 1,
        },
        circleOptions: {
          fillColor: "#333333",
          fillOpacity: 0.1,
          strokeWeight: 3,
          strokeColor: "#000000",
          strokeOpacity: 0.8,
          clickable: false,
          editable: true,
          zIndex: 1,
        },
      });

      google.maps.event.addListener(
        this.drawingManager,
        "drawingmode_changed",
        () => {
          if (this.drawingManager?.getDrawingMode() !== null) {
            this.clearShapes();
          }
        },
      );

      google.maps.event.addListener(
        this.drawingManager,
        "circlecomplete",
        (circle) => {
          this.allShapes.forEach((s) => {
            s.setMap(null);
          });
          this.allShapes = [];
          this.currentCircle = circle;
          this.allShapes.push(circle);
          this.currentPolygon = undefined;
          this.initCircleListeners(circle);
          this.updateGeofenceData();
          this.drawingManager?.setDrawingMode(null);
        },
      );

      google.maps.event.addListener(
        this.drawingManager,
        "polygoncomplete",
        (polygon) => {
          this.allShapes.forEach((s) => {
            s.setMap(null);
          });
          this.allShapes = [];
          let newPoly = new google.maps.Polygon({
            paths: polygon.getPath().getArray(),
            editable: true,
          });
          polygon.setMap(null);
          newPoly.setMap(this.map!.googleMap!);
          this.currentPolygon = newPoly;
          this.allShapes.push(newPoly);
          this.currentCircle = undefined;
          this.circleRadius = undefined;
          this.initPolygonListeners(newPoly);
          this.updateGeofenceData();
          this.drawingManager?.setDrawingMode(null);
        },
      );

      this.drawingManager.setMap(this.map.googleMap!);

      this.updateGeofenceData();
    }
  }

  _renderIntersecting() {
    this.intersectingGeofences?.forEach((intersecting) => {
      if (
        intersecting.roundAsGeoJson !== undefined &&
        intersecting.roundAsGeoJson !== null
      ) {
        this.allShapes.push(
          this.addCircle(
            intersecting.roundAsGeoJson,
            intersecting.round_radius!,
            false,
          ),
        );
      } else if (
        intersecting.areaAsGeoJson !== undefined &&
        intersecting.areaAsGeoJson !== null
      ) {
        this.allShapes.push(this.addPolygon(intersecting.areaAsGeoJson, false));
      }
    });
  }

  addCircle(
    jsonStr: any,
    radius: number,
    editable: boolean,
  ): google.maps.Circle {
    const json = JSON.parse(jsonStr);
    var bounds = new google.maps.LatLngBounds();
    var circle = new google.maps.Circle({
      center: {
        lat: json.coordinates[1],
        lng: json.coordinates[0],
      },
      radius: radius,
      editable: editable,
      fillColor: editable ? "#000" : "#FF0000",
      fillOpacity: editable ? 0.5 : 0.2,
      strokeColor: editable ? "#000" : "#FF0000",
    });
    circle.setMap(this.map?.googleMap!);
    if (editable) {
      this.initCircleListeners(circle);
      bounds.union(circle.getBounds());
      this.map?.fitBounds(bounds);
      this.updateGeofenceData();
    }
    return circle;
  }

  addPolygon(jsonStr: any, editable: boolean): google.maps.Polygon {
    const json = JSON.parse(jsonStr) as any;
    var bounds = new google.maps.LatLngBounds();
    var polycoords = json.coordinates[0].map((coord: any) => {
      return new google.maps.LatLng(coord[1], coord[0]);
    });
    var polygon = new google.maps.Polygon({
      paths: polycoords,
      editable: editable,
      fillColor: editable ? "#000" : "#FF0000",
      fillOpacity: editable ? 0.5 : 0.2,
      strokeColor: editable ? "#000" : "#FF0000",
    });
    polygon.setMap(this.map?.googleMap!);
    if (editable) {
      this.initPolygonListeners(polygon);
      json.coordinates[0].forEach((path: any) => {
        bounds.extend({
          lat: path[1],
          lng: path[0],
        });
      });
      this.map?.fitBounds(bounds);
      this.updateGeofenceData();
    }
    return polygon;
  }

  get geofenceDTO() {

    let geofenceDTO: any = {
      name: this.geofenceForm.controls['geofenceName'].value,
      timeout: this.geofenceForm.controls['geofenceTimeout'].value,
      min_accuracy: this.geofenceForm.controls['minAccuracy'].value || 100,
      on_property: this.geofenceForm.controls['onProperty'].value,
      foreign_key: this.geofenceForm.controls['foreignId'].value,
      competitor: this.geofenceForm.controls['competitor'].value,
      facility_floor_id: this.geofenceForm.controls['onProperty'].value
        ? this.facilityControl?.value
        : null,
      round_radius: null,
      tags: this.geofenceForm.controls['tags'].value,
    };

    if (this.geofence) {
      geofenceDTO = { ...this.geofence, ...geofenceDTO };
    }

    if (this.currentCircle) {
      geofenceDTO.round_radius = this.currentCircle.getRadius();
      geofenceDTO.round_center = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [
            this.currentCircle?.getCenter().lng(),
            this.currentCircle?.getCenter().lat(),
          ],
        },
        properties: {},
      };
      geofenceDTO.geojson = geofenceDTO.round_center;
    } else if (this.currentPolygon) {
      geofenceDTO.area = this.area;
      geofenceDTO.geojson = this.area;
    }

    return geofenceDTO;
  }

  get saveDisabled() {
    return this.geofenceForm.invalid;
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue!;
  }

  saveNewGeofence() {
    let dto = this.geofenceDTO as GeofenceDTO;

    // don't allow save if no facility floor is set when is on property
    // TODO: is there a way to do this with angular forms?
    if (dto.on_property && dto.facility_floor_id == null) {
      console.log("Set Floor!");
      return;
    }
    if (
      dto.round_radius == null &&
      dto.round_center == null &&
      dto.area == null
    ) {
      console.log("Set Polygon or Circle!");
      return;
    }
    this.uiService
      .waitForEvent(
        this.GeofenceService.createGeofence(this.currentAccount.accountID, dto),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        (saved) => {
          let geofence: GeofenceDTO = <GeofenceDTO>(<unknown>saved);
          this.NotificationService.openSuccessSnackBar(
            "Geofence created successfully",
          );
          this.router.navigate([geofence.id], {
            relativeTo: this.activatedRoute.parent,
          });
        },
        () => {
          this.NotificationService.openErrorSnackBar("Error creating geofence");
        },
      );
  }

  saveGeofenceUpdates() {
    let dto = this.geofenceDTO as GeofenceDTO;

    // don't allow save if no facility floor is set when is on property
    // TODO: is there a way to do this with angular forms?
    if (dto.on_property && dto.facility_floor_id == null) {
      console.log("Set Floor!");
      return;
    }
    this.uiService
      .waitForEvent(
        this.GeofenceService.updateGeofence(this.currentAccount.accountID, dto),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        () => {
          this.NotificationService.openSuccessSnackBar(
            "Geofence updated successfully",
          );
          this.uiService
            .waitForEvent(
              this.GeofenceService.getIntersectingGeofences(
                this.currentAccount.accountID,
                dto.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe((results) => {
              this.uiService
                .waitForEvent(
                  this.GeofenceService.getGeofence(
                    this.currentAccount.accountID,
                    dto.id,
                  ),
                )
                .pipe(takeUntil(this.onComponentDestroy))
                .subscribe(
                  (res) => {
                    this.intersectingGeofences =
                      results as unknown as GeofenceDTO[];
                    this.intersectionsDataSource = new MatTableDataSource(
                      this.intersectingGeofences,
                    );
                    this.geofence = res as unknown as GeofenceDTO;
                    this.initMap();
                  },
                  () => {
                    this.NotificationService.openErrorSnackBar(
                      "Error retrieving updated geofence",
                    );
                  },
                );
            });
        },
        () => {
          this.NotificationService.openErrorSnackBar("Error updating geofence");
        },
      );
  }

  cancel() {
    this.router.navigate(["list"], {
      relativeTo: this.activatedRoute.parent!.parent,
    });
  }

  deleteGeofence() {}

  onPlaceChange(event: Address) {
    if (this.map) {
      if (event.geometry.viewport) {
        this.map.fitBounds(event.geometry.viewport);
      }
    }
    // TODO: why isn't this working?
    this.geofenceForm.patchValue({
      placeName: "",
    });
  }

  setCircleTool() {
    this.drawingManager?.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE);
    // render intersecting
    this._renderIntersecting();
  }

  setPolyTool() {
    this.drawingManager?.setDrawingMode(
      google.maps.drawing.OverlayType.POLYGON,
    );
    // render intersecting
    this._renderIntersecting();
  }

  setPanTool() {
    this.drawingManager?.setDrawingMode(null);
    if (this.currentCircle) {
      this.currentCircle.setDraggable(true);
    } else if (this.currentPolygon) {
      this.currentPolygon.setDraggable(true);
    }
  }

  clearShapes() {
    this.allShapes.forEach((s) => {
      s.setMap(null);
    });
    this.allShapes = [];
    this.currentCircle?.setMap(null);
    this.currentPolygon?.setMap(null);
    this.currentCircle = undefined;
    this.circleRadius = undefined;
    this.currentPolygon = undefined;
  }

  initCircleListeners(circle: google.maps.Circle) {
    google.maps.event.addListener(circle, "radius_changed", () => {
      this.updateGeofenceData();
    });

    google.maps.event.addListener(circle, "center_changed", () => {
      this.updateGeofenceData();
    });
  }

  initPolygonListeners(polygon: google.maps.Polygon) {
    google.maps.event.addListener(polygon.getPath(), "set_at", (index, obj) => {
      this.updateGeofenceData();
    });

    google.maps.event.addListener(
      polygon.getPath(),
      "insert_at",
      (index, obj) => {
        this.updateGeofenceData();
      },
    );

    google.maps.event.addListener(
      polygon.getPath(),
      "remove_at",
      (index, obj) => {
        this.updateGeofenceData();
      },
    );
  }

  updateGeofenceData() {
    if (this.currentCircle) {
      this.circleCenter = this.currentCircle.getCenter();
      this.circleRadius = this.currentCircle.getRadius();
      this.area = undefined;
    } else if (this.currentPolygon) {
      let geoJson = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [[]] as any,
        },
        properties: {},
      };
      var points = this.currentPolygon.getPath().getArray();
      points.forEach((pt: LatLng) => {
        geoJson.geometry.coordinates[0].push([pt.lng(), pt.lat()]);
      });

      this.area = geoJson;
      this.circleCenter = undefined;
      this.circleRadius = undefined;
    }
  }

  addTag(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || "").trim()) {
      this.geofenceForm.controls.tags.value.push(value.trim());
    }

    if (input) {
      input.value = "";
    }
  }

  removeTag(tag: string): void {
    const index = this.geofenceForm.controls.tags.value.indexOf(tag);

    if (index! >= 0) {
      this.geofenceForm.controls.tags.value.splice(index!, 1);
    }
  }

  edit(geofence: GeofenceDTO) {
    this.router.navigate([geofence.id], {
      relativeTo: this.activatedRoute.parent!.parent,
    });
  }

  delete(geofence: GeofenceDTO) {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this geofence ( ${geofence.name} )?`,
            warning: "Warning: this is not reversible!",
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.uiService
            .waitForEvent(
              this.GeofenceService.deleteGeofence(
                this.currentAccount!.accountID,
                geofence.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar(
                  "Geofence deleted",
                );
                this.uiService
                  .waitForEvent(
                    this.GeofenceService.getIntersectingGeofences(
                      this.currentAccount!.accountID,
                      this.geofence?.id!,
                    ),
                  )
                  .pipe(takeUntil(this.onComponentDestroy))
                  .subscribe((geofences) => {
                    this.intersectingGeofences =
                      geofences as unknown as GeofenceDTO[];
                    this.intersectionsDataSource = new MatTableDataSource(
                      this.intersectingGeofences,
                    );
                    this.geofencesTable.renderRows();
                    this.intersectionsDataSource.sort = this.sort;
                  });
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting geofence",
                );
              },
            );
        }
      });
  }
}
